import React from "react";
import { Component } from "react";
import Icon from "../../../icon";
class WhatsHappeningList extends Component {
    render(){
        return(
            <div className="whats-happening-list-container">
                
                {this.props.listData.map((list,index)=>
                    <div key={index}>
                        <div>
                            <Icon                   
                                name={list.type==="Reminder" ? "bell-solid"  : list.type==="Survey" ? "file-lines-solid": ""}     
                                size="25px"                    
                            />
                        </div>
                        <div>
                            <h2>{list.title}</h2>
                            <span>{list.date}</span>
                        </div>
                        <div>
                            <span>View Details</span>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default WhatsHappeningList;